<div class="approval-progress" *ngIf="status; else loading">
  <div class="progress-track">
    <div class="progress-bar-inner" [ngClass]="status?.progressPercentage === 100 ? 'full' : ''"
      [style.width.%]="status?.progressPercentage || 0"></div>
  </div>
  <div class="progress-info">
    <span class="progress-label">{{ status?.progressStatus }}</span>
    <span class="progress-percentage">{{ status?.progressPercentage || 0 }}%</span>
  </div>
</div>
<ng-template #loading>{{ loader }}</ng-template>
